import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserData"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6H22.5V12H21V6ZM17.25 3.75H18.75V12H17.25V3.75ZM13.5 7.5H15V12H13.5V7.5ZM12 22.5H10.5V18C10.4988 16.7579 9.49213 15.7512 8.25 15.75H5.25C4.00787 15.7512 3.00124 16.7579 3 18V22.5H1.5V18C1.50248 15.93 3.17996 14.2525 5.25 14.25H8.25C10.32 14.2525 11.9975 15.93 12 18V22.5ZM6.75 6.75C7.99264 6.75 9 7.75736 9 9C9 10.2426 7.99264 11.25 6.75 11.25C5.50736 11.25 4.5 10.2426 4.5 9C4.5 7.75736 5.50736 6.75 6.75 6.75ZM6.75 5.25C4.67893 5.25 3 6.92893 3 9C3 11.0711 4.67893 12.75 6.75 12.75C8.82107 12.75 10.5 11.0711 10.5 9C10.5 8.00544 10.1049 7.05161 9.40165 6.34835C8.69839 5.64509 7.74456 5.25 6.75 5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserData.vue"]]);
